export function createBuildState() {
  return {
    status: 'loading',
    error: null,
    catalog: null,
    readyBlueprints: [],
    category: 'ready',
    selectedId: null,
    editingId: null,
    cursor: [0, 0, 0],
    rotationDeg: 0,
    revision: 0,
    plotId: null,
    plotVersion: null,
    capabilities: [],
    isOwner: false,
    placements: [],
    authorityOnline: false,
    pending: [],
    undoPending: false,
  }
}

export function buildReducer(state, action) {
  switch (action.type) {
    case 'LOAD_SUCCESS':
      return { ...state, status: 'ready', error: null, catalog: action.catalog, readyBlueprints: action.readyBlueprints || [], selectedId: action.readyBlueprints?.[0]?.id || action.catalog.modules[0]?.id || null }
    case 'LOAD_ERROR':
      return { ...state, status: 'error', error: action.error }
    case 'SELECT_CATEGORY':
      return { ...state, category: action.category, selectedId: action.selectedId ?? state.selectedId, editingId: null }
    case 'SELECT_ITEM':
      return { ...state, selectedId: action.id, editingId: null }
    case 'SELECT_PLACEMENT':
      return { ...state, editingId: action.placement.id, selectedId: null, cursor: action.placement.transform.positionM.slice(), rotationDeg: action.placement.transform.rotationDeg[1], error: null }
    case 'MOVE_CURSOR':
      return { ...state, cursor: state.cursor.map((value, index) => value + (action.delta[index] || 0)) }
    case 'ROTATE':
      return { ...state, rotationDeg: state.rotationDeg + action.step }
    case 'CANCEL_SELECTION':
      return { ...state, selectedId: null, editingId: null }
    case 'SET_SNAPSHOT':
      return {
        ...state,
        revision: action.snapshot.revision,
        placements: action.snapshot.placements,
        plotId: action.snapshot.plotId ?? null,
        plotVersion: action.snapshot.plotVersion ?? null,
        capabilities: action.snapshot.capabilities || [],
        isOwner: action.snapshot.isOwner === true,
        editingId: action.snapshot.placements.some(item => item.id === state.editingId) ? state.editingId : null,
        authorityOnline: action.snapshot.authorityOnline ?? state.authorityOnline,
      }
    case 'OPTIMISTIC_PLACE':
      return { ...state, pending: [...state.pending, action.placement], error: null }
    case 'UNDO_STARTED':
      return { ...state, undoPending: true, error: null }
    case 'MUTATION_STARTED':
      return { ...state, undoPending: true, error: null }
    case 'COMMAND_ACCEPTED':
      return {
        ...state,
        revision: action.snapshot.revision,
        placements: action.snapshot.placements,
        plotId: action.snapshot.plotId ?? state.plotId,
        plotVersion: action.snapshot.plotVersion ?? state.plotVersion,
        capabilities: action.snapshot.capabilities || state.capabilities,
        isOwner: action.snapshot.isOwner ?? state.isOwner,
        editingId: action.snapshot.placements.some(item => item.id === state.editingId) ? state.editingId : null,
        authorityOnline: action.snapshot.authorityOnline ?? true,
        pending: state.pending.filter(item => item.sourceCommandId !== action.commandId),
        undoPending: false,
        error: null,
      }
    case 'COMMAND_REJECTED':
      return {
        ...state,
        error: action.code,
        pending: state.pending.filter(item => item.sourceCommandId !== action.commandId),
        undoPending: false,
        ...(action.snapshot ? { revision: action.snapshot.revision, placements: action.snapshot.placements } : {}),
      }
    case 'CLEAR_ERROR':
      return { ...state, error: null }
    default:
      return state
  }
}
